import React from 'react';

export function QuestionMenu({ visible, x, y, onChooseAnotherQuestion, onCropAnswer, onClose }) {
  if (!visible) return null;

  return (
    <div className="ctxMenu" style={{ left: `${x}px`, top: `${y}px` }} onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        onClick={() => {
          onChooseAnotherQuestion?.();
          onClose?.();
        }}
      >
        Choose another question
      </button>
      <button
        type="button"
        onClick={() => {
          onCropAnswer?.();
          onClose?.();
        }}
      >
        Crop answer
      </button>
    </div>
  );
}

